var _excluded = ["active", "ascending", "children", "className", "onSort"];
import _JSXStyle from "styled-jsx/style";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Icon from '../../Icon/Icon';

var Header = _ref => {
  var active = _ref.active,
      ascending = _ref.ascending,
      children = _ref.children,
      className = _ref.className,
      onSort = _ref.onSort,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("th", _extends({
    onClick: onSort,
    style: {
      cursor: onSort ? 'pointer' : 'initial'
    }
  }, props, {
    className: "jsx-208054809" + " " + (props && props.className != null && props.className || className || "")
  }), children, onSort && /*#__PURE__*/React.createElement(Icon, {
    name: active ? `caret-${ascending ? 'up' : 'down'}` : 'sort',
    fixedWidth: true
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "208054809"
  }, "th.jsx-208054809{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}"));
};

Header.displayName = "Header";
Header.displayName = 'Header';
Header.defaultProps = {
  active: false,
  ascending: true
};
export default Header;